<div class="container" *ngIf="!isNotStartTaskField">
    <div class="one-item" *ngFor="let item of value;index as i" (click)="onClick($event,item)">
        <a href="#" target="_blank" [title]="item.fileName">{{item.fileName}}</a>
        <span *ngIf="(value.length-1)>i">,&nbsp;</span>
    </div>
</div>
<div *ngIf="isNotStartTaskField">
    <span class='not-start-field'>{{'general.not_start' | stringLiterals}}</span>
</div>